import http from './http';

export const authAPI = {
  signup: async (data) => {
    const response = await http.post('/api/auth/signup', data);
    return response.data;
  },

  login: async (data) => {
    const response = await http.post('/api/auth/login', data);
    return response.data;
  },
};








